<template>
  <v-card flat class="my-0">
    <v-card-text>
      <v-text-field
        v-model="field.mask"
        v-bind:label="$t('Mask')"
      ></v-text-field>
      <v-text-field
        v-model="defaultValue"
        type="number"
        v-bind:label="$t('DefaultValue')"
        @change="applyDefaultValueRestrictions"
      ></v-text-field>
      <v-text-field
        v-model="field.minVal"
        type="number"
        v-bind:label="$t('MinValue')"
        @change="applyDefaultValueRestrictions"
      ></v-text-field>
      <v-text-field
        v-model="field.maxVal"
        type="number"
        v-bind:label="$t('MaxValue')"
        @change="applyDefaultValueRestrictions"
      ></v-text-field>
      <v-text-field
        v-model="field.scale"
        type="number"
        v-bind:label="$t('Decimals')"
        @change="applyDefaultValueRestrictions"
      ></v-text-field>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  props: {
    field: {
      type: Object,
      default: () => ({}),
    },
    validator: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    defaultValue: {
      get: function () {
        var userDecSep = this.$store.getters["account/user"].MetricDecimalSep;
        var userThouSep = this.$store.getters["account/user"].MetricThousandSep;
        return this.field.default
          .replaceAll(userThouSep, "")
          .replaceAll(userDecSep, ".");
      },
      set: function (newValue) {
        var userDecSep = this.$store.getters["account/user"].MetricDecimalSep;
        this.field.default = newValue.replaceAll(".", userDecSep);
      },
    },
  },
  methods: {
    applyDefaultValueRestrictions() {
      if (!this.defaultValue) {
        return;
      }
      var number = parseFloat(this.defaultValue);
      if (
        (this.field.maxVal || this.field.maxVal == 0) &&
        number > parseFloat(this.field.maxVal)
      ) {
        number = parseFloat(this.field.maxVal);
      }
      if (
        (this.field.minVal || this.field.minVal == 0) &&
        number < parseFloat(this.field.minVal)
      ) {
        number = parseFloat(this.field.minVal);
      }
      this.defaultValue = number.toFixed(this.field.scale || 0);
    },
  },
};
</script>